export default __webpack_public_path__ + "media/zurb/img/development-process/data-2a3830cd897402cff0d1afbf7be568aa.png";